import React from 'react'
import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import VideoDetail from 'components/VideoDetail'
import { ConfigStore } from 'stores/config'
import { EventsStore } from 'stores/events'
import { StoriesStore } from 'stores/stories'
import { PlaylistsStore } from 'stores/playlists'
import { useStoryPageView, useStore } from 'hooks'
import { getServerSideWrapper } from 'utils/data-fetching'
import THEME from 'utils/theme'
import find from 'lodash/find'

const PlaylistDetailPage = ({ id, slug, latestEvent, playlist, story, currentVideoSource, videoListTitle, global }) => {
  useStore(StoriesStore, { current: story, videoList: playlist.stories, currentVideoSource })
  useStore(PlaylistsStore, { current: playlist })
  useStore(EventsStore, { current: latestEvent })
  useStore(ConfigStore, { current: global.config })

  useStoryPageView(story)

  return (
    <SiteLayout background={THEME.COLORS.BACKGROUND_GRAY} showNavBarCTA useAvailableEventLogo={false}>
      <Head playlist={playlist} canonical={`${process.env.SITE_URL}/playlist/${id}/${slug}`} />
      <VideoDetail title={videoListTitle} type='playlists' />
    </SiteLayout>
  )
}

export const getServerSideProps = getServerSideWrapper(async ({ params, query }) => {
  const { id, slug } = params
  const { video = null } = query

  const playlist = await PlaylistsStore().findById(id)

  let storyId = playlist.stories[0].id
  if (video) {
    const overrideStory = find(playlist.stories, { id: Number(video) })
    if (overrideStory) {
      storyId = overrideStory.id
    }
  }

  const [latestEvents, story, currentVideoSource] = await Promise.all([
    EventsStore().findRNR(),
    StoriesStore().findById(storyId),
    StoriesStore().findVideoSource(storyId)
  ])
  return {
    latestEvent: latestEvents?.[0] || null,
    playlist,
    story,
    video,
    id,
    slug,
    currentVideoSource,
    videoListTitle: playlist.title
  }
})

export default PlaylistDetailPage
